import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import { loadErrorMessages, loadDevMessages } from '@apollo/client/dev';
import { ApolloProvider } from '@apollo/client/react';
import { useSelector } from 'react-redux';

import { selectAccountId } from '@/redux/session/selectors';
import { X_MOVEO_ACCOUNT_ID } from '@/util/constants';
import { isDevOrLocal } from '@/util/util';

const ApolloProviderWithAccountId = ({ children }) => {
  const accountId = useSelector(selectAccountId);

  if (isDevOrLocal()) {
    // Adds messages only in a dev environment
    loadDevMessages();
    loadErrorMessages();
  }

  /**
   * Initializes an Apollo Client instance for managing GraphQL operations.
   *
   * - Configures the client with a GraphQL endpoint URI (`/www/api/v1/graphql`).
   * - Sets up an in-memory cache with type policies for the `Query` type,
   *   including a custom key argument for the `get_session` field.
   *
   * @constant
   */
  const client = new ApolloClient({
    link: new HttpLink({
      uri: '/www/api/v1/graphql',
      headers: { [X_MOVEO_ACCOUNT_ID]: accountId, 'x-request-source': 'tooling' },
    }),
    cache: new InMemoryCache({
      typePolicies: {
        Query: {
          fields: {
            get_session: { keyArgs: ['args', ['session_id']] },
            get_simulation: { keyArgs: ['args', ['session_id']] },
          },
        },
      },
    }),
    defaultOptions: { watchQuery: { notifyOnNetworkStatusChange: true } },
  });

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default ApolloProviderWithAccountId;
